<template>
  <OnuBoard :state=boardState />
</template>

<script>
import OnuBoard from "device/status/modules/OnuBoard.vue"

export default {
  name: "PonTreePortGraph",

  props: {
    state: Object,
    extra: Object,
  },  
  
  data()
  {
    return {
      boardState: {
        device: 0,
        mac: "",
      },
    }
  },
  
  components: {OnuBoard},
  
  watch: {
    "extra.onu":
    {
      immediate: true,
      handler()
      {
        if (!this.extra?.onu) return

        this.boardState = {
          device: this.extra.onu.device,
          mac: this.extra.onu.mac,
        }
      },
    },
  },
}
</script>